class FieldGroupFormatter {

  setCriteria(criteria) {
    this._criteria = criteria;
    return this
  }
  
  async mount() {
    return this.makeGroup(this._criteria.getProperties(), await this._criteria.getCustomFields()) 
  }

  makeGroup(properties, customFields) {
    return [
      {fieldType: 'property',  fields: [...this.formatFieldsToScreen(properties, 'property')]},
      {fieldType: 'customField',  fields: [...this.formatFieldsToScreen(customFields, 'customField')]},
    ]
  }
  // eslint-disable-next-line
  formatFieldsToScreen(fields, valueFieldType) {

  }

  formatType(type) {
    if (type == 'I' || type == 'M')
      return 'media'
    return 'data'
  }

}

export default FieldGroupFormatter